class TwoFactorSuccessController {
    constructor($state) {
        "ngInject";
        this.$state = $state;
    }

    done() {
        this.$state.go("deployments");
    }
}

export default TwoFactorSuccessController; 


// WEBPACK FOOTER //
// ./sources/components/auth/two-factor/two-factor-success.controller.js